import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { QuestionsParams, Question, Answer } from '../questions.interface';

export const setQuestions = createAction(
  '[Questions Component] Set Questions',
  props<{ questions: BackendResponse<Question>; params: QuestionsParams; pageNumber: number }>()
);

export const updateQuestion = createAction('[Questions Component] Update Question', props<{ question: Question }>());

export const updateManyQuestions = createAction(
  '[Questions Component] Update Many Questions',
  props<{ questions: { ids: string[]; changes: Partial<Question> } }>()
);

export const updateAnswer = createAction('[Questions Component] Update Answer', props<{ answer: Answer; questionId: string }>());

export const switchSelection = createAction('[Questions Component] Switch Selection', props<{ id: string }>());

export const switchAllSelection = createAction('[Questions Component] Switch All Selection', props<{ checked: boolean }>());

// Requests

export const loadQuestions = createAction('[Requests/Api Questions] Load Questions', (params: QuestionsParams, pageNumber: number = 1) => ({
  params,
  pageNumber
}));

export const changeQuestionStatus = createAction('[Requests/Api Questions] Change Question Status', props<{ id: string }>());

export const changeManyQuestionsStatus = createAction(
  '[Requests/Api Questions] Change Many Questions Status',
  props<{ payload: { ids: string[]; muted: string } }>()
);

export const editAnswer = createAction('[Requests/Api Questions] Edit Answer', props<{ id: string; answer: string; userId: string }>());

export const createAnswer = createAction('[Requests/Api Questions] Create Answer', props<{ id: string; answer: string; userId: string }>());
